import bModal from './modal.vue';

export default bModal;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/modal/modal.js
// module id = 512
// module chunks = 0